import {RequireSome} from '@wandb/weave/common/types/base';
import React from 'react';

import {MediaBrowserPanelConfig} from './common';

type PanelHeaderProps = {
  config: RequireSome<MediaBrowserPanelConfig, 'chartTitle'>;
};

const PanelHeaderComp = ({config}: PanelHeaderProps) => {
  const {chartTitle} = config;

  return (
    <div className="mb-6 flex w-full items-center justify-center">
      <h6 data-test="media-chart-title">{chartTitle}</h6>
    </div>
  );
};

export const PanelHeader = React.memo(PanelHeaderComp);
